module.exports = __webpack_public_path__ + "img/outside2.5c2372ed.jpg";